<div class="d-lg-flex align-items-center" rt="top-bar-container">
  <common-icon-button
    class="ml-auto"
    *ngIf="createButtonText"
    iconClass="icon-add"
    [buttonText]="createButtonText"
    rt="common-index-table-add-button"
    (click)="createEntity.emit()"
  >
  </common-icon-button>
</div>
<div class="mt-2" rt="table-container">
  <div class="card table-card" *ngIf="rows?.length">
    <ngx-datatable
      rt="table"
      #apiTable
      [rows]="rows"
      [selectionType]="undefined"
      [columns]="columns"
      [headerHeight]="50"
      [footerHeight]="125"
      [rowHeight]="initial"
      columnMode="force"
    >
    </ngx-datatable>
  </div>
  <div class="card table-card p-4" *ngIf="rows?.length == 0">0 results</div>
</div>

<ng-template #statusTemplate let-row="row" let-value="value">
  <div class="float-right float-lg-none">
    <common-status-label [status]="value"></common-status-label>
  </div>
</ng-template>

<ng-template #currencyTemplate let-row="row" let-value="value">
  {{ value | currency : "USD" }}
</ng-template>

<ng-template #linkTemplate let-row="row" let-value="value" let-column="column">
  <a class="text-green cursor-pointer" [attr.href]="linkClick(row, column)" [innerHtml]="value"></a>
</ng-template>

<ng-template #checkMarkTemplate let-row="row" let-value="value" let-column="column">
  <div [innerHtml]="value"></div>
</ng-template>

<ng-template #actionsTemplate let-row="row" let-value="value" let-column="column" let-rowIndex="rowIndex">
  <ng-template
    let-actions="computedActions"
    #selfie
    [ngTemplateOutlet]="selfie"
    [ngTemplateOutletContext]="{ computedActions: getComputedActions(column, row) }"
  >
    <div class="btn-group btn-group-action btn-block" role="group" *ngIf="actions.length">
      <button type="button" class="btn btn-secondary py-2" *ngIf="actions[0].click" (click)="actions[0].click(row)" [attr.rt]="'view-' + rowIndex">
        {{ actions[0].label }}
      </button>
      <a class="btn btn-secondary" *ngIf="actions[0].routerLink" [routerLink]="actions[0].routerLink" [queryParams]="actions[0].queryParams">
        {{ actions[0].label }}
      </a>

      <div ngbDropdown container="body" class="d-inline-block" *ngIf="actions.length > 1">
        <button class="btn btn-secondary more-actions" ngbDropdownToggle><i class="icon-carrot py-1"></i></button>
        <div class="br-0" ngbDropdownMenu>
          <ng-container *ngFor="let action of actions | slice : 1">
            <button ngbDropdownItem *ngIf="action.click" (click)="action.click(row)" [disabled]="action.disable" [attr.rt]="'view-' + rowIndex">
              {{ action.label }}
            </button>
            <a
              ngbDropdownItem
              *ngIf="action.routerLink"
              [routerLink]="actions[0].routerLink"
              [queryParams]="actions[0].queryParams"
              [disabled]="action.disable"
              [attr.rt]="'view-' + rowIndex"
              >{{ action.label }}</a
            >
          </ng-container>
        </div>
      </div>
    </div>
  </ng-template>
</ng-template>
